import { z } from 'zod';

export const RepSearchResultModel = z.object({
  id: z.string(),
  name: z.string(),
  district: z.string(),
  region: z.string(),
  territory: z.string(),
});
export type RepSearchResult = z.infer<typeof RepSearchResultModel>;
